import React from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { i18n } from 'constant/String';
import { Large } from 'components';
import CreateDeliveryMethodForm from './CreateDeliveryMethodForm';
import { apiResHandler } from 'utils/axiosBaseQuery';
import {
  useCreateNewDeliveryMethodMutation,
  useUpdateDeliveryMethodMutation,
} from 'redux/slices/deliveryMethod/deliveryMethodApi';
import { useDispatch } from 'react-redux';
import { addAlertQueue } from 'redux/slices/snackbar/snackbarSlice';

const CreateDeliveryMethod = ({ data: modalData, onCancel }) => {
  const dispatch = useDispatch();
  const [createNewDeliveryMethod] = useCreateNewDeliveryMethodMutation();
  const [updateDeliveryMethod] = useUpdateDeliveryMethodMutation();
  const schema = yup
    .object({
      description: yup.string().required(i18n.errors.required),
      formatCode: yup.string().required(i18n.errors.required),
      shortName: yup.string().required(i18n.errors.required),
      details: yup.string().required(i18n.errors.required),
    })
    .required(i18n.errors.required);
  const methods = useForm({
    defaultValues: { ...modalData },
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    if (modalData) {
      apiResHandler(
        updateDeliveryMethod({ data: { ...data, id: modalData.id } }),
        () => {
          dispatch(
            addAlertQueue({
              message: 'Teslimat Biçimi Güncellendi',
              status: 'success',
              show: true,
            })
          );

          onCancel();
        },
        ({ message }) => {
          dispatch(
            addAlertQueue({
              message: message,
              status: 'error',
              show: true,
            })
          );

          onCancel();
        }
      );
    } else {
      apiResHandler(createNewDeliveryMethod({ data }), () => {
        dispatch(
          addAlertQueue({
            message: 'Teslimat Biçimi Eklendi',
            status: 'success',
            show: true,
          })
        );

        onCancel();
      }),
        ({ message }) => {
          dispatch(
            addAlertQueue({
              message: message,
              status: 'error',
              show: true,
            })
          );
          onCancel();
        };
    }
  };

  return (
    <>
      <Large className="text-center" weight="semibold">
        {modalData ? 'Teslimat Biçimi Güncelle' : 'Yeni Teslimat Biçimi Ekle'}
      </Large>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit)}
          className="flex flex-col w-full gap-y-4 md:mt-10 items-center h-full"
        >
          <CreateDeliveryMethodForm onCancel={onCancel} />
        </form>
      </FormProvider>
    </>
  );
};

export default CreateDeliveryMethod;

CreateDeliveryMethod.propTypes = {
  onSubmit: PropTypes.func,
  data: PropTypes.object,
  onCancel: PropTypes.func,
};
